import { Container, Grid, Stack } from '@mui/material';
import pluralize from 'pluralize';
import React from 'react';

import { useFolded2025Data } from '~components/business-owner/Folded2025/hooks/useFolded2025Data';

import styles from './Folded2025PickupAndDelivery.module.scss';

import PickupAndDeliveryIcon from '../../assets/PUD_Icon.svg?react';
import LeftDecoration from '../../assets/PUD_LeftDecoration.svg?react';
import RightDecoration from '../../assets/PUD_RightDecoration.svg?react';
import Folded2025Card from '../Folded2025Card';
import Folded2025Title from '../Folded2025Title';

const Folded2025PickupAndDelivery = (): JSX.Element => {
	const { data } = useFolded2025Data();

	return (
		<div className={styles.container}>
			<LeftDecoration className={styles.leftDecoration} />
			<RightDecoration className={styles.rightDecoration} />
			<Container disableGutters>
				<Folded2025Title icon={<PickupAndDeliveryIcon />}>
					Pickup and Delivery
				</Folded2025Title>

				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Folded2025Card style={{ alignItems: 'center' }}>
							<Folded2025Card.Value size="xxl">
								{Number(
									data?.summary?.pickup_delivery
										?.total_orders_delivered,
								).toLocaleString()}
							</Folded2025Card.Value>
							<Folded2025Card.Label>
								Total{' '}
								{pluralize(
									'order',
									data?.summary?.pickup_delivery
										?.total_orders_delivered,
								)}{' '}
								delivered
							</Folded2025Card.Label>
						</Folded2025Card>
					</Grid>

					<Grid item xs={12} md={4}>
						<Folded2025Card>
							<Folded2025Card.Label>Fan favorite</Folded2025Card.Label>
							<Folded2025Card.Value>
								{
									data?.summary?.pickup_delivery?.fan_favorite_service
										.service_name
								}
							</Folded2025Card.Value>
							<Folded2025Card.Label>
								Top ordered service
							</Folded2025Card.Label>
						</Folded2025Card>
					</Grid>

					<Grid item xs={12} md={4}>
						<Folded2025Card>
							<Folded2025Card.Label>Hotwheels</Folded2025Card.Label>
							<Folded2025Card.Value>
								{data?.summary?.pickup_delivery?.hot_wheels
									?.delivery_time_minutes
									? `${Number(
											Math.round(
												data.summary.pickup_delivery.hot_wheels
													.delivery_time_minutes,
											),
									  ).toLocaleString()} minutes`
									: ''}
							</Folded2025Card.Value>
							<Folded2025Card.Label>
								Shortest delivery route
							</Folded2025Card.Label>
						</Folded2025Card>
					</Grid>

					<Grid item xs={12} md={4}>
						<Folded2025Card>
							<Folded2025Card.Label>Roadtrip</Folded2025Card.Label>
							<Folded2025Card.Value>
								{data?.summary?.pickup_delivery?.road_trip
									?.delivery_time_minutes
									? `${Number(
											Math.round(
												data.summary.pickup_delivery.road_trip
													.delivery_time_minutes,
											),
									  ).toLocaleString()} minutes`
									: ''}
							</Folded2025Card.Value>
							<Folded2025Card.Label>
								Longest delivery route
							</Folded2025Card.Label>
						</Folded2025Card>
					</Grid>
				</Grid>
			</Container>
		</div>
	);
};

export default Folded2025PickupAndDelivery;
